import React from "react";

/**
 * Simple spinner icon that inherits the current text color unless overridden.
 */
export default function LoadingSpinner({ className = "h-4 w-4 text-current" }) {
  const combined = ["animate-spin", className].filter(Boolean).join(" ");

  return (
    <svg
      className={combined}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
